import { toaster } from '../components/ui/toaster';

export interface ToastOptions {
  title?: string;
  description?: string;
  status?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  isClosable?: boolean;
}

/**
 * Hook for showing toast notifications
 */
export function useToast() {
  const toast = (options: ToastOptions) => {
    const { title, description, status = 'info', duration = 5000, isClosable = true } = options;

    return toaster.create({
      title,
      description,
      type: status,
      duration,
      closable: isClosable,
    });
  };

  return toast;
}
